import AsyncStorage from '@react-native-async-storage/async-storage'

const SESSION_KEY = 'relayably.auth.session'

const browserStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }

  return null
}

export const sessionStorage = {
  async get() {
    const storage = browserStorage()

    if (storage) {
      return storage.getItem(SESSION_KEY)
    }

    return AsyncStorage.getItem(SESSION_KEY)
  },

  async set(value: string) {
    const storage = browserStorage()

    if (storage) {
      storage.setItem(SESSION_KEY, value)
      return
    }

    await AsyncStorage.setItem(SESSION_KEY, value)
  },

  async clear() {
    const storage = browserStorage()

    if (storage) {
      storage.removeItem(SESSION_KEY)
      return
    }

    await AsyncStorage.removeItem(SESSION_KEY)
  },
}
